import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import useNativeListener from '@hooks/useNativeListener';
import { useFlow } from '@router/stackflow';
import { useQueryClient } from '@tanstack/react-query';
import NativeUtil from '@utils/NativeUtil';

type PushType = 'NOTICE' | 'EVENT' | 'COUPON' | 'URL';

type AppState = 'FOREGROUND' | 'BACKGROUND';

interface PushMessage {
  pushType?: PushType,
  pushArg?: string,
  appState: AppState;
}

function usePushMessage() {
  const { push } = useFlow();
  const queryClient = useQueryClient();
  const toast = useToast();
  // 푸시 메시지 수신 리스너
  useNativeListener('onPushMessageReceive', (data: PushMessage) => {
    console.log({ message: 'push message received', data });
    queryClient.invalidateQueries({ queryKey: queries.user._def });
    queryClient.invalidateQueries({ queryKey: queries.notifications._def });
    queryClient.invalidateQueries({ queryKey: queries.orders._def });

    const { pushType, pushArg, appState } = data;
    if (appState === 'BACKGROUND') {
      switch (pushType) {
        case 'NOTICE':
          if (pushArg) {
            push('NoticeActivity', { noticeId: pushArg });
          }
          return;
        case 'EVENT':
          if (pushArg) {
            push('EventActivity', { eventId: pushArg });
          }
          return;
        case 'COUPON':
          push('CouponActivity', { type: 'DOWNLOAD' });
          break;
        case 'URL':
          NativeUtil.postMessage('openExternalLink', pushArg);
          break;
        default:
          break;
      }
    } else {
      toast.info('새로운 알림이 도착했습니다.');
    }
  });
}

export default usePushMessage;
